<template>
  <iModal
    :visible="isOpen"
    :open="isOpen"
    title="Create New Contract"
    primary-action-button-label="Create Contract"
    :primary-action-button-loading="isLoadingCreateContract"
    :max-width="600"
    @close="closeModal"
    @click:primary="handleSubmit"
  >
    <template #body>
      <iColumn gap="large">
        <iColumn gap="none">
          <iTextInput
            v-model="form.name"
            label="Contract Name"
            required
            placeholder="Enter contract name"
            width="fill"
            @input="clearError('name')"
          />
          <iText v-if="errors.name" variant="error">
            {{ errors.name }}
          </iText>
        </iColumn>

        <iColumn gap="none">
          <iTextArea
            v-model="form.description"
            label="Description"
            required
            placeholder="Enter contract description"
            :rows="4"
            width="fill"
            @input="clearError('description')"
          />
          <iText v-if="errors.description" variant="error">
            {{ errors.description }}
          </iText>
        </iColumn>
      </iColumn>
    </template>
  </iModal>
</template>

<script>
import { mapState } from "pinia";
import { useUserStore } from "@/stores/user-store";
import { useOrganizationStore } from "@/stores/organization-store";
import { useContractStore } from "@/stores/contract-store";

export default {
  name: "CreateContractModal",
  components: {
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:is-open"],
  data() {
    return {
      form: {
        name: "",
        description: "",
        contracteeOrgId: null,
      },
      errors: {
        name: "",
        description: "",
        contracteeOrgId: "",
      },
      // TODO - with will be removed test code for dark deploy
      contracteeOptions: [
        { value: 1, label: "Organization One" },
        { value: 2, label: "Organization Two" },
        { value: 3, label: "Organization Three" },
      ],
    };
  },
  computed: {
    ...mapState(useOrganizationStore, ["getOrgData"]),
    orgId() {
      return this.getOrgData.org_id;
    },
    ...mapState(useUserStore, ["userId"]),
    ...mapState(useContractStore, ["isLoadingCreateContract"]),
  },
  methods: {
    clearError(field) {
      this.errors[field] = "";
    },

    validate() {
      let isValid = true;

      if (!this.form.name) {
        this.errors.name = "Contract name is required";
        isValid = false;
      }

      if (!this.form.description) {
        this.errors.description = "Description is required";
        isValid = false;
      }

      return isValid;
    },

    handleSubmit() {
      if (!this.validate()) {
        return;
      }

      const contractStore = useContractStore();

      contractStore.createContract(
        this.orgId,
        this.form.name,
        this.form.description,
        this.form.contracteeOrgId,
        this.userId,
        () => {
          this.resetForm();
          this.closeModal();
        },
      );
    },
    resetForm() {
      this.form = {
        name: "",
        description: "",
        contracteeOrgId: null,
      };
      this.errors = {
        name: "",
        description: "",
        contracteeOrgId: "",
      };
    },
    closeModal() {
      this.$emit("update:is-open", false);
    },
  },
};
</script>
